// Logout page
import React from 'react';
import { endBriefingNewSession } from '../helpers/preFlightBriefing';

export class Logout extends React.Component {
  // Redirect to logout route in server
  logout() {
    endBriefingNewSession();
    window.location.href = process.env.REACT_APP_SERVER_URL + '/logout6';
  }

  render() {
    return (
      <div
        className="logout-container"
        onClick={() => this.logout()}
        style={{ marginLeft: '2px' }}
      >
        <span>LOGOUT</span>
      </div>
    );
  }
}
